// src/pages/projects/Delivery.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectDetail.module.css';

import adminImg from '../../assets/DeliverySC/admin.png';
import c1 from '../../assets/DeliverySC/customer/D1.png';
import c2 from '../../assets/DeliverySC/customer/D2.png';
import c3 from '../../assets/DeliverySC/customer/D3.png';
import c4 from '../../assets/DeliverySC/customer/D4.png';
import c5 from '../../assets/DeliverySC/customer/D5.png';
import c6 from '../../assets/DeliverySC/customer/D6.png';
import c7 from '../../assets/DeliverySC/customer/D7.png';
import d1 from '../../assets/DeliverySC/Deliver/del1.png';
import d2 from '../../assets/DeliverySC/Deliver/del2.png';

const images = [c1, c2, c3, c4, c5, c6, c7, d1, d2, adminImg];

export default function Delivery() {
  const [current, setCurrent] = useState(0);

  const nextImage = () => setCurrent((p) => (p + 1) % images.length);
  const prevImage = () => setCurrent((p) => (p - 1 + images.length) % images.length);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Delivery Management System</h1>

      <div className={styles.carousel}>
        <button onClick={prevImage} className={styles.navBtn}>❮</button>
        <img
          src={images[current]}
          alt={`Delivery Screenshot ${current + 1}`}
          className={`${styles.carouselImage} ${styles.fadeIn}`}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <button onClick={nextImage} className={styles.navBtn}>❯</button>
      </div>

      <p className={styles.description}>
        The <strong>Delivery Management System</strong> is a complete delivery platform built with <strong>JavaScript</strong> on the frontend using <strong>React (Vite)</strong>, and a backend API powered by <strong>Node.js</strong> with <strong>Express</strong>.
      </p>

      <p className={styles.description}>
        The application targets three user roles: <strong>Customer</strong>, <strong>Delivery Driver</strong>, and <strong>Admin</strong>. Screenshots are provided above from the customer and driver views, plus the admin dashboard.
      </p>

      <h3 className={styles.subtitle}>Pages & Key Features</h3>

      <p className={styles.description}>
        <strong>Landing Page:</strong> Includes sections like <em>Our Popular Food</em>, <em>Choose Restaurant</em>, and product browsing. Customers can add items to their cart directly from product listings.
      </p>

      <p className={styles.description}>
        <strong>Add To Cart:</strong> Quick add functionality from product tiles and a mini cart summary for fast checkout.
      </p>

      <p className={styles.description}>
        <strong>Cart Page:</strong> Full cart review with quantity updates, coupon support, and checkout flow that creates an order in the backend.
      </p>

      <p className={styles.description}>
        <strong>Order History:</strong> Customers can view past orders with details, timestamps, and receipt information.
      </p>

      <p className={styles.description}>
        <strong>Track Order:</strong> Real-time order tracking with discrete status steps: <em>Order Received</em> → <em>Driver Assigned</em> → <em>On The Way</em> → <em>Delivered</em>. Each step updates from the backend and is visible to the customer.
      </p>

      <p className={styles.description}>
        <strong>Driver / Delivery Side:</strong>
        <br />• <em>My Active Deliveries</em>: Drivers see a list of assigned deliveries that are still pending or in-progress.
        <br />• <em>Update Delivery Status</em>: Drivers can update status values such as <em>Accepted</em>, <em>Preparing</em>, <em>Delivering</em>, and <em>Completed</em>.
      </p>

      <p className={styles.description}>
        <strong>Admin Panel:</strong> A centralized dashboard to control users, places/restaurants, products, orders, and driver reports. Admins can manage CRUD operations and view system-wide reports.
      </p>

      <ul className={styles.features}>
        <li>✅ Role-based views: Customer, Driver, Admin</li>
        <li>✅ Real-time order status and tracking steps</li>
        <li>✅ Add-to-cart, cart management, and order history</li>
        <li>✅ Driver workflow: accept, update, complete deliveries</li>
        <li>✅ Admin control over users, restaurants/places, products, and orders</li>
      </ul>

      <div className={styles.buttonGroup}>
        <Link to="/" className={styles.backBtn}>← Back to Home</Link>
      </div>
    </div>
  );
}
